import { Timestamp } from 'firebase/firestore';

class Milestone {
  id!: string;
  dateCreated!: Timestamp;
  createdById!: string;
  type!: MilestoneTypes;
}

enum MilestoneTypes {
  CountReservationByUser = 'CountReservationByUser',
  CountReservationByCompany = 'CountReservationByCompany',
  CountConversionByUser = 'CountConversionByUser',
  CountConversionByCompany = 'CountConversionByCompany',
}

class MilestoneCountReservationByUser extends Milestone {
  reservationId!: string;
  userId!: string;
  username!: string;
  companyId!: string;
  companyName!: string;
  count!: number;
}

class MilestoneCountReservationByCompany extends Milestone {
  reservationId!: string;
  companyId!: string;
  companyName!: string;
  count!: number;
}

class MilestoneCountConversionByUser extends Milestone {
  reservationId!: string;
  userId!: string;
  username!: string;
  companyId!: string;
  companyName!: string;
  count!: number;
}

class MilestoneCountConversionByCompany extends Milestone {
  reservationId!: string;
  companyId!: string;
  companyName!: string;
  count!: number;
}

export {
  Milestone,
  MilestoneTypes,
  MilestoneCountReservationByUser,
  MilestoneCountReservationByCompany,
  MilestoneCountConversionByUser,
  MilestoneCountConversionByCompany,
};
